import React, { useEffect, useState, useRef } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { replaceUrlParam } from "../../common/utils";

import {
  fetchCouriers,
  filterCouriers,
  fetchCourierByID,
  selectCouriers,
  fetchMoreCouriers,
  getFullList,
} from "./couriersSlice";

import Grid from "@material-ui/core/Grid";
import CouriersList from "./CouriersList";

const useStyles = makeStyles((theme) => ({
  progress: {
    margin: theme.spacing(2),
  },
}));

export default function CouriersContainer(props) {
  let jwtToken = localStorage.getItem("coreToken");
  const dispatch = useDispatch();
  const classes = useStyles();
  const [courierNames, setCourierNames] = useState([]);
  const [courierIDs, setCourierIDs] = useState([]);
  const edit = props.location.pathname.includes("edit");
  const {
    couriers,
    error,
    loading,
    couriersList,
    couriersFilter,
    courier,
    lastQuery,
    couriersAmount,
  } = useSelector(selectCouriers);

  const [statusNames, setStatusNames] = useState([]);
  const [statusIDs, setStatusIDs] = useState([]);
  const [statusList, setStatusList] = useState([
    { id: 1, value: "Active", name: "Active" },
    { id: 2, value: "Inactive", name: "Inactive" },
    { id: 3, value: "Deleted", name: "Deleted" },
    { id: 4, value: "Unavailable", name: "Unavailable" },
  ]);

  const [numberShown, setNumberShown] = useState(25);
  const [moreProducts, setMoreProducts] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [sortProperty, setSortProperty] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");

  const handleCouriersChange = (event) => {
    let idsArr = [];
    // event.target.value.forEach((selected) => {
    let selectedCourier = couriersList.filter(
      (courier) => courier.name === event.target.value
    );
    selectedCourier && idsArr.push(selectedCourier[0].id);
    // });

    setCourierNames(event.target.value);
    setCourierIDs(idsArr);
  };

  const handleStatusChange = (event) => {
    let idsArr = [];
    event.target.value.forEach((selected) => {
      let selectedStatus = statusList.filter(
        (status) => status.name === selected
      );
      selectedStatus[0] && idsArr.push(selectedStatus[0].id);
    });

    setStatusNames(event.target.value);
    setStatusIDs(idsArr);
  };

  useEffect(() => {
    let searchQuery = lastQuery ? lastQuery : "";

    if (rowsPerPage) {
      searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);
    }
    dispatch(
      fetchCouriers({
        token: jwtToken,
        query: lastQuery ? searchQuery : `?limit=${rowsPerPage}`,
      })
    );

    setNumberShown(rowsPerPage);
  }, [dispatch, rowsPerPage]);

  const getFullListTrigger = () => {
    let searchQuery = lastQuery ? lastQuery : "";
    searchQuery = replaceUrlParam(searchQuery, "limit", 100);

    dispatch(
      getFullList({
        token: jwtToken,
        offset:
          rowsPerPage > couriersList.length ? rowsPerPage : couriersList.length,
        query: searchQuery,
        targetLength: couriersAmount,
      })
    );
  };

  const [ready, setReady] = useState(false);
  if (loading === "loaded" && !ready) {
    setReady(true);
  }

  const handleEdit = (id) => {
    dispatch(
      fetchCourierByID({
        id: id,
        token: jwtToken,
      })
    );
  };

  const handleEditClick = (id) => {
    dispatch(
      fetchCourierByID({
        id: id,
        token: jwtToken,
      })
    );
  };

  const handleMore = (e, page) => {
    if (page < currentPage) {
      setCurrentPage(page);
      setNumberShown((page + 1) * rowsPerPage);
    } else {
      let expectedLen = (page + 1) * rowsPerPage;
      if (
        couriersList.length < couriersAmount &&
        couriersList.length < expectedLen
      ) {
        dispatch(
          fetchMoreCouriers({
            token: jwtToken,
            query: lastQuery,
            offset: numberShown,
          })
        );
      } else if (couriersList.length == couriersAmount) {
        setMoreProducts(false);
      }
      setCurrentPage(currentPage + 1);
      setNumberShown((currentPage + 2) * rowsPerPage);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = sortProperty === property && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortProperty(property);
    switch (property) {
      case "updatedAt":
        property = "updated_at";
        break;
      case "createdAt":
        property = "created_at";
        break;
      case "statusID":
        property = "status_id";
        break;
      case "supplierName":
        property = "supplier_name";
        break;
      case "brandName":
        property = "brand_name";
        break;
      case "rrp":
        property = "rrp_margin";
        break;
      case "costPrice":
        property = "cost_price";
        break;
      case "sellingPrice":
        property = "selling_price";
        break;
    }

    let searchQuery = lastQuery ? lastQuery : "";

    if (property) {
      searchQuery = replaceUrlParam(searchQuery, "order_by", property);
    }
    searchQuery = replaceUrlParam(searchQuery, "sort", isAsc ? "desc" : "asc");
    searchQuery = replaceUrlParam(searchQuery, "limit", rowsPerPage);

    dispatch(
      fetchCouriers({
        token: jwtToken,
        query: searchQuery,
      })
    );
  };

  const handleSearch = () => {
    let searchQuery = lastQuery ? lastQuery : "";

    if (statusIDs.length) {
      searchQuery = replaceUrlParam(
        searchQuery,
        "statuses",
        statusIDs.join(",")
      );
    }

    if (searchTerm) {
      searchQuery = replaceUrlParam(searchQuery, "name", searchTerm);
    }

    console.log("searchQuery", searchQuery);
    dispatch(
      fetchCouriers({
        query: searchQuery,
        token: jwtToken,
      })
    );
    setCurrentPage(0);
  };

  const handleClear = () => {
    setCourierNames([]);
    setCourierIDs([]);
    setStatusNames([]);
    setStatusIDs([]);

    setSearchTerm("");

    setSortDirection(null);
    setSortProperty(null);

    dispatch(
      fetchCouriers({
        token: jwtToken,
        query: `?limit=${rowsPerPage}`,
      })
    );
    setCurrentPage(0);
  };

  const selectNames = ["status"];

  const headCells = [
    {
      id: "name",
      checked: true,
      numeric: false,
      disablePadding: false,
      label: "Name",
      long: true,
      sortable: true
    },
    {
      id: "baseURL",
      numeric: false,
      disablePadding: false,
      label: "Base URL",
      checked: true,
      long: true,
    },
    {
      id: "createdAt",
      numeric: false,
      disablePadding: false,
      label: "Created Date",
      checked: true,
      long: false,
      sortable: true
    },
    {
      id: "updatedAt",
      numeric: false,
      disablePadding: false,
      label: "Last Updated",
      checked: true,
      long: false,
      sortable: true
    },
    {
      id: "statusID",
      numeric: false,
      disablePadding: false,
      label: "Status",
      checked: true,
      long: false,
      sortable: true,
    },
  ];

  const [rowList, setRowList] = useState([...headCells]);

  let content;
  if (loading === "loading") {
    content = (
      <CircularProgress className={classes.progress} color="secondary" />
    );
  } else if (loading === "loaded") {
    content = (
      <CouriersList
        couriers={couriers}
        handleCouriersChange={handleCouriersChange}
        courierNames={courierNames}
        courierIDs={courierIDs}
        handleStatusChange={handleStatusChange}
        statusNames={statusNames}
        statusList={statusList}
        handleSearch={handleSearch}
        handleClear={handleClear}
        handleEdit={handleEdit}
        handleEditClick={handleEditClick}
        selectNames={selectNames}
        noChecks={true}
        rowList={rowList}
        setRowList={setRowList}
        headCells={headCells}
        productsAmount={couriersAmount}
        handleMore={handleMore}
        page={currentPage}
        setPage={setCurrentPage}
        handleRequestSort={handleRequestSort}
        sortProperty={sortProperty}
        sortDirection={sortDirection}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        getFullList={getFullListTrigger}
      />
    );
  }
  // else if (loading === 'error') {
  //   content = <Error error={{message: 'Something went wrong'}} />;
  // }

  return (
    <Grid
      container
      spacing={3}
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      style={{ height: "100%" }}
    >
      {content}
    </Grid>
  );
}
